import React from 'react'
import UnauthRoutes from './UnauthRoutes';
import { useSelector } from 'react-redux';
import { ROLE_ADMIN, ROLE_AGENCY, ROLE_DEPARTMENT_MANGER, ROLE_INFLUENCER, ROLE_KEEPER, ROLE_MANAGER, ROLE_SUPPLIER_MANAGER, ROLE_WORKER } from '../constants';
import AgencyRoutes from './AuthRoutes/Agency';
import InfluencerRoutes from './AuthRoutes/Influencer';
import { removeToken } from '../utils';

const BaseRoutes = () => {
  const user = useSelector(state => state.user);
  
  if (!user) {
    return <UnauthRoutes />;
  }

  switch (user.role) {
    case ROLE_ADMIN.value:
      removeToken();
      return <UnauthRoutes />;
    case ROLE_AGENCY.value:
      return <AgencyRoutes />;
    case ROLE_INFLUENCER.value:
      return <InfluencerRoutes />;
    default:
      return null;
  }
}

export default BaseRoutes;